import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useVoted } from "@/lib/cards";
import { MysteryCard } from "@/components/MysteryCard";

export function MysteryCarousel() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const voted = useVoted();
  const ref = useRef(null);
  useEffect(() => { api.get("/featured").then((r) => setItems(r.data.items)).catch(() => {}); }, []);
  if (!items.length) return null;
  const step = () => (ref.current.firstChild?.offsetWidth || 1) + 16;
  const onScroll = () => setIdx(Math.min(items.length - 1, Math.round(ref.current.scrollLeft / step())));
  return (
    <section data-testid="mystery-carousel" className="space-y-5" aria-labelledby="carousel-title">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="luma-eyebrow">Una selezione per te</p>
          <h2 id="carousel-title" data-testid="carousel-title" className="mt-1 text-2xl font-extrabold sm:text-[32px]">Da dove cominciamo?</h2>
        </div>
        <Link to="/misteri" data-testid="carousel-all-link" className="flex min-h-[44px] shrink-0 items-center text-sm font-bold text-[var(--luma-action)] hover:underline">Tutti i misteri →</Link>
      </div>
      <div ref={ref} onScroll={onScroll} className="-mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 [scrollbar-width:none] lg:mx-0 lg:grid lg:grid-cols-3 lg:gap-5 lg:overflow-visible lg:px-0">
        {items.map((d, i) => (
          <MysteryCard key={d.id} d={d} voted={voted.has(d.id)} testid={`carousel-card-${d.id}`}
            className="fade-up w-[82vw] max-w-[330px] shrink-0 snap-start lg:w-auto lg:max-w-none" style={{ animationDelay: `${i * 60}ms` }} />
        ))}
      </div>
      <div className="flex items-center justify-center gap-1.5 lg:hidden" aria-hidden="true">
        {items.map((d, i) => (
          <button key={d.id} tabIndex={-1} onClick={() => ref.current.scrollTo({ left: i * step(), behavior: "smooth" })}
            className={`h-1.5 rounded-full transition-all ${i === idx ? "w-6 bg-[var(--luma-action)]" : "w-1.5 bg-[#BFD6E8]"}`} />
        ))}
      </div>
    </section>
  );
}
